import { Controller } from '@hotwired/stimulus'
import * as Toastr from 'toastr'

export default class extends Controller {
  static targets = ['trixEditor', 'subject']

  validate(event) {
    if (!this.validateSubject(event)) {
      return false
    }

    if (!this.validateTrix(event)) {
      return false
    }

    return true
  }

  validateSubject(event) {
    if (this.hasSubjectTarget) {
      const subject = this.subjectTarget.value.trim()

      if (subject.length === 0) {
        event.preventDefault()
        event.stopPropagation()
        Toastr.error('Please enter a subject before sending.')
        this.subjectTarget.focus()
        return false
      }
    }

    return true
  }

  validateTrix(event) {
    if (this.hasTrixEditorTarget) {
      const trixEditor = this.trixEditorTarget
      
      if (trixEditor && trixEditor.editor) {
        const content = trixEditor.editor.getDocument().toString().trim()
        
        if (content.length === 0) {
          event.preventDefault()
          event.stopPropagation()
          Toastr.error('Please enter a message before sending.')
          trixEditor.focus()
          return false
        }
      }
    }

    return true
  }
}

